export default "__VITE_ASSET__D6X0Fsb2__"